import { req } from '../../@api/request';

export default class QuantService {
  static list = async (data: { theme: string; category: string; ctpCode: string; limit: number; offset: number }) => {
    const result = await req.get(`/quant?theme=${data.theme}&category=${data.category}&ctpCode=${data.ctpCode}&limit=${data.limit}&offset=${data.offset}`);
    return result.data;
  };

  static stats = async (data: { theme: string; category: string; ctpCode: string; }) => {
    const result = await req.get(`/quant/stats?theme=${data.theme}&category=${data.category}&ctpCode=${data.ctpCode}`);
    return result.data;
  };
}